import { getAuthData } from "./../utils/getAuthData";
import React, { useEffect } from "react";

export const useAuthData = (logger: any, updateUserInfo?: boolean) => {
  const [userInfo, setUserInfo] = React.useState<any>(false);
  useEffect(() => {
    getAuthData(logger).then(({ userInfo }) => {
      setUserInfo(userInfo);
    });
  }, [updateUserInfo]);
  return { userInfo };
};
